module.exports = __webpack_public_path__ + "img/default-stage.db4fdab9.png";